<section class="services-area ptb-100">
    <div class="container">
        <div class="section-title">
            <!-- <span class="sub-title">Education for everyone</span> -->
            <h2>Hizmetlerimiz​</h2>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.</p> -->
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="services-box">
                    <div class="icon">
                        <i class='bx bx-line-chart'></i>
                    </div>
                    <h3>Dijital Reklam Yönetimi</h3>
                    <p>Markanızı hedef kitlenize en doğru şekilde ulaştırmak için performans odaklı dijital reklam
                        kampanyaları yönetiyoruz.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="services-box">
                    <div class="icon">
                        <i class='bx bx-camera'></i>
                    </div>
                    <h3>Fotoğraf ve Video Prodüksüyon</h3>
                    <p>Profesyonel fotoğraf ve video çekimleri ile markanızın hikayesini anlatıyoruz. </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="services-box">
                    <div class="icon">
                        <i class='bx bxl-instagram'></i>
                    </div>
                    <h3>Sosyal Medya Yönetimi</h3>
                    <p>Etkili içerik stratejileri ve kreatif paylaşımlarla sosyal medyada güçlü bir marka algısı
                        oluşturuyoruz.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="services-box">
                    <div class="icon">
                        <i class='bx bx-laptop'></i>
                    </div>
                    <h3>Web Sitesi Tasarımı</h3>
                    <p>Mobil uyumlu, hızlı ve kullanıcı dostu web siteleri tasarlayarak dijital varlığınızı
                        güçlendiriyoruz.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="services-box">
                    <div class="icon">
                        <i class='bx bxs-phone'></i>
                    </div>
                    <h3>Mobil Uygulama</h3>
                    <p>İhtiyaçlarınıza özel, modern ve kullanıcı dostu mobil uygulamalar tasarlayıp geliştiriyoruz.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="services-box">
                    <div class="icon">
                        <i class='bx bx-user-pin'></i>
                    </div>
                    <h3>Marka ve Pazarlama Stratejisi</h3>
                    <p>Markanızı güçlendiren etkili pazarlama stratejileri oluşturuyoruz.</p>
                </div>
            </div>
            <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="services-btn">
                    <a routerLink="/register" class="default-btn"><i
                            class='bx bx-user-circle icon-arrow before'></i><span class="label">Get Started
                            Today</span><i class="bx bx-user-circle icon-arrow after"></i></a>
                </div>
            </div> -->
        </div>
    </div>
    <!-- <div class="divider bg-e4feff"></div> -->
</section>